import './Vista3dView.scss'
import 'aframe'

import { Entity, Scene } from 'aframe-react'
import React, { Component } from 'react'

import { ESCALADO_DISTANCIA_EN_X, SECTORES, TIPOS_SILO, TORRE1, TORRE2 } from '../../../config/silos'
import { MovimientoUtils } from '../../../models/movimiento/movimientoUtils'
import { Loading } from '../../Forms/SharedComponents/components/MuiTable/Loading'
import Camara from '../containers/Camara'
import SectorJumper from './SectorJumper'
import SiloView from './SiloView'

class Silos3dView extends Component {
  calculateSectorHudPosition (index, total) {
    const x = (0.5 / total) * index - 0.25
    const y = 0.4
    const z = -0.55
    return `${x} ${y} ${z}`
  }

  calculatePosicionEnXDesplazadaAlSector (posicionx, sector) {
    return (SECTORES[sector].startingXPosition + (posicionx * ESCALADO_DISTANCIA_EN_X))
  }

  render () {
    const { data: silos, isLoading, escalaDeRadio, onSiloClicked, sectores, onSectorSelected, updateHuds } = this.props
    const silosToRender = []
    if (silos) {
      silos
        .filter(silo => silo.sector !== 'S5')
        .forEach(silo => {
          silosToRender.push(
            <SiloView
              key={silo.nombreCorto}
              position={`${this.calculatePosicionEnXDesplazadaAlSector(silo.posicionX, silo.sector)} ${0} ${silo.posicionZ}`}
              isEntreSilo={silo.tipo === TIPOS_SILO.ENTRESILO}
              radius={silo.radio * escalaDeRadio}
              height={silo.altura}
              color={silo.color || 'white'}
              // color={'white'}
              nucleoColor={MovimientoUtils.getNucleoColor(silo.nucleo) || 'white'}
              topConeHeight={silo.alturaConoSuperior || 0}
              bottomConeHeight={silo.alturaConoInferior || 0}
              metrosLleno={silo.alturaTotal - (silo.metrosDeVacio)}
              onClick={() => onSiloClicked(silo)}
            />
          )
        })
    }
    const sectoresHudToRender = []
    const sectoresToRender = []
    if (sectores) {
      Object.keys(sectores).forEach((sector, i) => {
        sectoresToRender.push(
          <Entity
            primitive='a-plane'
            position={`${sectores[sector].startingXPosition + (sectores[sector].xLarge / 2)} 0 ${sectores[sector].startingZPosition + (sectores[sector].zLarge / 2)}`}
            rotation='-90 0 0'
            width={sectores[sector].xLarge}
            height={sectores[sector].zLarge}
            color={sectores[sector].color}
            transparent
            opacity={sectores[sector].transparency}
          />
        )

        sectoresHudToRender.push(
          <SectorJumper
            key={sector}
            name={sector}
            position={this.calculateSectorHudPosition(i, Object.keys(sectores).length)}
            color='white'
            onClick={() => onSectorSelected({ ...sectores[sector], name: `  ${sector} ` })}
          />
        )
      })
    }
    updateHuds(sectoresHudToRender)
    return (
      <div style={{ height: '600px' }}>
        {!isLoading && (
          <Scene embedded>
            <Entity primitive='a-light' type='ambient' color='#445451' />
            <Entity primitive='a-light' type='point' intensity='2' position='-400 300 200' color='#445451' />
            <Entity primitive='a-sky' color='#dddddd' radius='10000' />
            <Camara />
            <Entity
              primitive='a-box'
              position={`${TORRE1.startingXPosition + TORRE1.xLarge / 2} ${TORRE1.altura / 2} ${TORRE1.startingZPosition +
                TORRE1.zLarge / 2}`}
              width={TORRE1.xLarge}
              depth={TORRE1.zLarge}
              height={TORRE1.altura}
              color={TORRE1.color}
              transparent
              opacity={TORRE1.transparency}
            />
            <Entity
              primitive='a-box'
              position={`${TORRE2.startingXPosition + TORRE2.xLarge / 2} ${TORRE2.altura / 2} ${TORRE2.startingZPosition + TORRE2.zLarge / 2}`}
              width={TORRE2.xLarge}
              depth={TORRE2.zLarge}
              height={TORRE2.altura}
              color={TORRE2.color}
              transparent
              opacity={TORRE2.transparency}
            />
            {sectoresToRender}
            {silosToRender}
          </Scene>
        )}
        {isLoading && <Loading />}
      </div>
    )
  }
}

export default Silos3dView
